/**
 * @file index.tsx
 *
 * @fileoverview Renders blog badges - categories and tag.
 */

import { useContext } from 'react';
import BlogSearchCategories, {
  BlogSearchCategoriesProps,
} from '~/jobiqo/components/BlogSearch/components/Categories';
import BlogTagBadge, {
  BlogTagBadgeProps,
} from '~/jobiqo/components/Blog/components/TagBadge';
import { PathContext } from '~/jobiqo/context/app';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { FlexItem } from '~/vcl/atoms/06-layout/03-flex/02-flex-item';

interface BlogSearchBadgesProps
  extends BlogSearchCategoriesProps,
    BlogTagBadgeProps {}

export default function BlogSearchBadges({
  categories,
  tag,
  currentCategory,
}: BlogSearchBadgesProps) {
  const { pathname } = useContext(PathContext);
  const showTags = pathname === '/blog/tag/[tagName]' && tag;

  return (
    <FlexItems
      justifyContent="center"
      flexDirection="column"
      gap={5}
      alignItems="center"
    >
      <FlexItem>
        <BlogSearchCategories
          categories={categories}
          currentCategory={currentCategory}
        />
      </FlexItem>
      {showTags && (
        <FlexItem>
          <BlogTagBadge tag={tag} />
        </FlexItem>
      )}
    </FlexItems>
  );
}
